module.exports = __webpack_public_path__ + "img/product-25.80c6678d.jpg";